// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui.secondary.pointing.menu{margin:0 0 0 80px}.light-theme .ui.secondary.pointing.menu a.item.active{border-bottom:2px solid #065b74}.dark-theme .ui.secondary.pointing.menu a.item.active{border-bottom:2px solid #05495d}", ""]);
// Exports
module.exports = exports;
